namespace Vit.Administration {
    export interface UserTenantRoleRow {
        UserTenantRoleId?: number;
        UserId?: string;
        RoleId?: number;
        TenantId?: number;
        Username?: string;
        User?: string;
        TenantName?: string;
    }

    export namespace UserTenantRoleRow {
        export const idProperty = "UserTenantRoleId";
        export const localTextPrefix = "Administration.UserTenantRole";

        export declare const enum Fields {
            UserTenantRoleId = "UserTenantRoleId",
            UserId = "UserId",
            RoleId = "RoleId",
            TenantId = "TenantId",
            Username = "Username",
            User = "User",
            TenantName = "TenantName",
        }
    }
}